import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { FitMedProfile } from '@app/shared/models/data/fit-med-profile/FitMedProfile';
import { GeneralHelperService } from '@app/shared/services/helpers/general-helper/general-helper.service';
import {hasValue} from '@shared/utils/helpers';
import { LocalizedDatePipe } from '@shared/pipes/localized-date/localized-date.pipe';
import { GenderComponent } from '../../../../shared/components/gender/gender.component';
import { ProfilePictureComponent } from '../../../../shared/components/profile-picture/profile-picture.component';

@Component({
    selector: 'app-patient-detail-medium',
    templateUrl: './patient-detail-medium.component.html',
    styleUrls: ['./patient-detail-medium.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ProfilePictureComponent, GenderComponent, LocalizedDatePipe]
})
export class PatientDetailMediumComponent implements OnInit {
  fullName: string = null;
  fitMedProfileId: string = null;
  fitMedProfile: FitMedProfile = null;

  @Input() set patientFitMedProfile(content: FitMedProfile) {
    if (hasValue(content)) {
      this.fullName = `${content.firstName} ${content.lastName}`;
      this.fitMedProfileId = content.id;
      this.fitMedProfile = content;
    }
  }

  constructor(private generalHelperService: GeneralHelperService) { }

  ngOnInit(): void {
  }

  getAgeFromDOB(dob: string): string {
    return this.generalHelperService.dobStringToAge(dob);
  }

}
